import { DynamicAttributeValueInput } from "gql/graphql";
import { useDebouncedCallback } from "use-debounce";
import { useEffect, useMemo } from "react";
import { useFilterMeta } from "./use-filter-meta";
import { formFieldsToJson } from "../utils/form-fields-to-json";
import { FilterObject } from "./types";
import { filterObjectToFormFields } from "../utils/json-to-form-fields";
import { useFilter } from "./use-filter";
import Form from "@/shared/form/form";

export function useFilterForm<T extends FilterObject>() {
  const meta = useFilterMeta();
  const { innerFilterObject: filter, setFilter: _setFilter } = useFilter();

  function setFilter(value: DynamicAttributeValueInput[]) {
    _setFilter(formFieldsToJson(value) as T);
  }

  const debouncedSetFilter = useDebouncedCallback(setFilter, 400);

  const formFilterValue: DynamicAttributeValueInput[] = useMemo(() => {
    return filterObjectToFormFields(filter, meta);
  }, [filter, meta]);

  const [form] = Form.useForm<{ filters: DynamicAttributeValueInput[] }>();

  const onFieldsChange = () => {
    debouncedSetFilter(form.getFieldsValue().filters);
  };

  const initialValues = { filters: formFilterValue };

  useEffect(() => {
    form.setFieldsValue({ filters: formFilterValue });
  }, [form, formFilterValue]);

  return {
    form,
    onFieldsChange,
    initialValues,
  };
}
